<template>
  <div class="content pr-2">
    <div class="columns">
      <div class="column is-half">
        <h2 class="has-text-centered">
          F.A.Q's
        </h2>
        <hr>
        <strong>How Does it Work?</strong>
        <p>
          Official AHL Poker No Limit Texas Hold'em Tournaments are a form of entertainment designed to fill your establishment with customers that will enjoy your products and services. We license to participating restaurants, bars, and any place where food and beverages are sold.
        </p>
        <p>
          Founded in Dallas, Texas in 2006, AHL Poker set out to create a new era for amateur hold’em players and help participating establishments put an end to their slow nights. Player participation range from 30 to 500 players in a single tournament session. Thousands of new members sign up weekly.
        </p>
        <p>
          AHL Poker can provide venues with training, poker table tops, playing cards, chips, tournament rules and everything needed to run even the biggest of poker tournaments. The top 16 players at each session earn Official AHL Poker Player/Ranking Points.
        </p>
        <strong>Is my place a good fit? </strong>
        <p>
          Your place is a good fit if you have: Physical space for 5 to 16 tables that can seat 8 players each. Booths are not ideal for tournament play and should not be considered available space. A slow day or evening is where you will see the greatest impact.
        </p>
        <strong>How does this help Customers? </strong>
        <p>
          Players can play for free and have fun while testing their poker skills in a live tournament, all in the comfort of their favorite neighborhood bars and restaurants. AHL will also be bringing an established member base to your establishment on a nightly basis. Make sure you have a wait staff that is up to the challenge to take all those drink and food orders prior to and during tournament play. Your slow night may be become your busy night sooner than you think!
        </p>
        <strong>What's In It for My Business?</strong>
        <p>
          Increased sales on tournament nights! Players will spend 2 to 7 hours in your establishment. We ask all our players to support all of our Official AHL Poker Event Locations! We could not do this without you! Most venue owners report significant increases in food and beverage sales on tournament nights within the first two weeks and your likely to see some increase on your first night!
        </p>
        <p>
          Keep your business and liquor license safe! To read what makes a game legal or illegal and the state laws attached to this click the Read More button.
        </p>
        <a
          v-if="!expand"
          class="button is-info"
          @click="expand = !expand"
        >Expand</a>
        <div v-if="expand">
          <p>
            A night of fun for you and your customers and guaranteed repeat business!
          </p>
          <p>
            The benefit of free web advertising to bring in more customers! Our highly-exposed Web site lists tournament venues and session schedules and all participating bars and restaurants receive an internal web page within AHL Poker.com. Click the link below for an example,
            <a
              href="//www.ahlpoker.com/main.php?p=venue&id=207"
              target="_blank"
            >https//www.ahlpoker.com/venues/207</a>
          </p>
          <strong>How much does it cost? </strong>
          <p>
            By offering Full Service, AHL Team Events, and sliding scales it is possible to host AHL events on any budget! Full Service Hosting is as low as $150 nightly, and AHL Team Events are as low as $50.00.
          </p>
          <strong> Is it Legal?</strong>
          <p>
            YES, our players NEVER pay anything to play! No member fees, no cover charges, and no? buy-ins? ever! We conduct legal research on a regular basis to insure our services fall within the boundaries of local, state and federal laws.
          </p>
          <p>
            Many leagues will use illegal tactics to boost sales however, it's your establishment that's put at risk! TABC only goes after those that possess the TABC license not the league itself so be careful of leagues not approved by TABC. AHL Poker will keep you and your business safe!
          </p>
          <strong>Poker in restaurants and bars</strong>
          <p>
            <span class="tag is-danger">ILLEGAL</span>: Players pay a cash entry fee of from $25 to $50 to play.  The establishment does not keep any of the entry fee.  Rather, all of the fee is contributed to a prize pool that is paid out to the top finishers in the tournament.  The establishment does not charge a door fee or require any minimum purchase of food or beverage.  It profits only from any discretionary sales of any food or beverage to the players.  No gambling is otherwise allowed.  The players are given chips without further charge and wager these, with the prize pool being distributed to the top finishers based on the number of chips accumulated.
          </p>
          <p>
            <span class="tag is-info">LEGAL</span>: The play of the tournament is the same as in the first.  However, players neither pay an entry fee nor are charged a door fee or otherwise required to pay the establishment anything.  Again, the establishment only profits from discretionary sales of food or beverage to the players.  At the end of the tournament prizes put up directly or indirectly by the establishment are awarded to the top finishers.
            On June 20, 2005, the Texas Attorney General issued his Opinion No. GA-0335, which concluded:
            "A holder of an on-premises alcoholic beverage permit may not, without violating both section 47.04(a) of the Penal Code and Rule 35.31 of the Alcoholic Beverage Commission, host a poker tournament in which participants risk money or any other thing of value for the opportunity to win a prize. A holder of an on-premises alcoholic beverage permit may, without violating either section 47.04(a) of the Penal Code or Rule 35.31 of the Alcoholic Beverage Commission, host a poker tournament in which participants do not risk money or any other thing of value for the opportunity to win a prize."
          </p>
          <p>
            The Texas Attorney General has stated that as long as participants do not risk money or anything of value to try to win any prize, the game is not illegal under §47.02, which is how bars and restaurants hold legal tournaments. 7 Texas Penal Code §47.02(a)(3) states that a person commits an offense if he plays and bets for money or other thing of value at any game played with cards, dice, balls, or any other gambling device.
          </p>
          <strong>
            Charity poker: Please read and understand why we cannot be involved in charity events outside our own 501c. If you have an idea for a charity event, please make sure it meets the guidelines below.
          </strong>
          <br>
          <br>
          <p>
            The Charitable Raffling Enabling Act in Chapter 2002 of the Texas Occupations Code will rarely, if ever, apply to Texas Hold ‘Em fundraisers. Often, the business or association holding the event does not meet the requirements of a qualified organization (non-profits, fire departments, emergency medical services, and education). Even if the organization meets the stipulated requirements, the charity exception requires that a raffle be conducted to award prizes. Because a raffle is defined as “the award of one or more prizes by chance at a single occasion among a single pool or group of persons who have paid or promoted a thing of value for a ticket that represents a chance to win a prize,”9 players are prohibited from receiving prizes based on how far they advance or what place they finish in a poker tournament. Additionally, the code prohibits cash as a prize. The Attorney General has also made it clear that even nonprofit organizations that sponsor a “poker run” violate gambling statutes.10 Therefore, unless the raffle results are separate from the outcome of the poker tournament—begging the question, why play at all? Charities and other groups should not rely on Texas Hold ‘Em tournaments to raise funds.
          </p>
          <p>
            Contact The offices of AHL Poker at <a href="mailto:sales@ahlpoker.com">sales@ahlpoker.com</a> or call an AHL representative today and someone will be happy to help you schedule a meeting and end your slow nights for good!
          </p>
        </div>
        <a
          v-if="expand"
          class="button is-info"
          @click="expand = !expand"
        >Collapse</a>
      </div>
      <div class="column is-half">
        <h2 class="has-text-centered">
          Full Service
        </h2>
        <hr>
        <h5 class="has-text-centered">
          <strong>Do you own or manage a bar or restaurant?</strong>
        </h5>
        <h5 class="has-text-centered">
          <strong>Turn your slow nights around once and for all?</strong>
        </h5>
        <p>
          AHL Poker is just what you are looking for. The worldwide poker craze is big business and it.s only getting bigger.
        </p>
        <p>
          AHL Poker gives you the ability to host live, free tournaments at your place of business any night of the week.
        </p>
        The AHL provides:
        <ul>
          <li>Poker tabletops that will set atop your existing tables. </li>
          <li>All cards and chips (all cards and chips are the highest quality on the market)</li>
          <li>A professional/experienced Tournament director to host your tournaments. </li>
          <li>Posters/Banners for your establishment to help promote your events </li>
          <li>An internal webpage for your bar/restaurant on our website for you to advertise your establishment. AHL will maintain this page for you and keep your specials current. </li>
          <li>Tournament reports giving you details on turnout numbers </li>
        </ul>
        <p>
          Our members play for points and of course nightly AHL Free Rolls.
        </p>
        <p>
          Members keep track of their points on our online system, qualifying them for monthly tournaments and special events that can be hosted at your establishment. Our tournaments range between 40 and 100+ players per night. We provide two sessions a night lasting approximately 7 hours.
        </p>
        <p>
          Players also receive bonus chips for purchasing drinks and additional chips for purchasing food from your establishment. These add-ons give player incentive to purchase food and drink therefore increasing your sales.
        </p>
        <p>
          <strong>*Note*</strong> Some states prohibit food and drink chips by state law.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Services',
    metaInfo: {
      title: 'AHL Poker :: Services'
    },
    data () {
      return {
        expand: false
      }
    },
    computed: {},
    methods: {}
  }
</script>
